import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Translate from '@hydra/common/components/i18n';

import Label from '@hydra/common/components/Label';
import Criterium from '@hydra/common/criterium/Criterium';
import CriteriumIconAndText from '@hydra/common/criterium/CriteriumIconAndText';
import CriteriumTable from '@hydra/common/criterium/CriteriumTable';
import SafeAnchor from '@hydra/common/components/SafeAnchor';

const useStyles = makeStyles(theme => ({
  text: {
    marginBottom: theme.spacing(2)
  }
}));

export const WwwResolve = ({ criterium }) => {
  const classes = useStyles();
  const { data, url } = criterium;

  const { httpNonWww, httpWww, httpsNonWww, httpsWww, allResolveToSame } = data;
  const translatedText = <Translate component='div' className={classes.text} content={allResolveToSame ? 'wwwresolve_ok' : 'wwwresolve_nok'} />;
  if (!httpNonWww && !httpWww && !httpsNonWww && !httpsWww) {
    return (
      <Criterium
        criterium={criterium}
        variables={{ urlNonWww: url, domain: url }}
      >
        {translatedText}
      </Criterium>
    );
  }

  const resolveCheckTypes = [httpNonWww, httpWww, httpsNonWww, httpsWww].filter(type => type);
  const allUrlsResolvedText = allResolveToSame
    ? <Translate component='div' className={classes.text} content='wwwresolve_all_resolved_ok' />
    : <CriteriumIconAndText success={false} text={<Translate content='wwwresolve_all_resolved_ko' />} />;

  const head = [
    <Translate content='wwwresolve_url' key='wwwresolve_url' />,
    <Translate content='wwwresolve_resolved_url' key='wwwresolve_resolved_url' />
  ];

  const rows = resolveCheckTypes.map(type => {
    const { url, statusCode, resolvedUrl, errorCode } = type;
    return [
      <SafeAnchor href={url} rel='nofollow noopener noreferrer' target='_blank' key={url}>{url}</SafeAnchor>,
      resolvedUrl
        ? <SafeAnchor href={resolvedUrl} rel='nofollow noopener noreferrer' target='_blank'>{resolvedUrl}</SafeAnchor>
        : <Label inline style='error'>{errorCode || statusCode}</Label>
    ];
  });

  const content = (
    <>
      {translatedText}
      {allUrlsResolvedText}
      <CriteriumTable head={head} rows={rows} nowrap />
    </>
  );

  return (
    <Criterium
      criterium={criterium}
      variables={{ urlNonWww: url, domain: url }}
    >
      {content}
    </Criterium>
  );
};

WwwResolve.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      allResolveToSame: PropTypes.bool,
      httpNonWww: PropTypes.shape({
        url: PropTypes.string,
        statusCode: PropTypes.number,
        resolvedUrl: PropTypes.string,
        errorCode: PropTypes.string
      }),
      httpWww: PropTypes.shape({
        url: PropTypes.string,
        statusCode: PropTypes.number,
        resolvedUrl: PropTypes.string,
        errorCode: PropTypes.string
      }),
      httpsNonWww: PropTypes.shape({
        url: PropTypes.string,
        statusCode: PropTypes.number,
        resolvedUrl: PropTypes.string,
        errorCode: PropTypes.string
      }),
      httpsWww: PropTypes.shape({
        url: PropTypes.string,
        statusCode: PropTypes.number,
        resolvedUrl: PropTypes.string,
        errorCode: PropTypes.string
      })
    })
  })
};

export default React.memo(WwwResolve);
